module.exports = __webpack_public_path__ + "static/media/resourceLinkDownload.2a4aa5f2.svg";